// @ts-strict-ignore
import { AfterViewInit, DestroyRef, Directive, ElementRef, EventEmitter, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[minRowCount]'
})
export class MinRowCountDirective implements AfterViewInit {

  @Input() minRowCount: number;
  @Input() rowHeight: number = 45;
  @Input() update: EventEmitter<void>;

  constructor(
    private elementRef: ElementRef,
    private destroyRef: DestroyRef
  ) {}

  ngAfterViewInit(): void {
    this.changeDOM();

    if (this.update) {
      this.update.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        setTimeout(() => this.changeDOM(), 0);
      });
    }
  }

  private changeDOM() {

    this.minRowCount = this.minRowCount || 5;

    const body: HTMLElement = this.elementRef.nativeElement;
    const head: HTMLElement = this.findHead(body);
    const columnCount = head.children[0].children.length;

    while (body.children.length - this.minRowCount > 0) {
      const lastRow = body.lastElementChild;
      if (lastRow.classList.contains(`table-row-empty`)) {
        body.removeChild(lastRow);
      } else {
        break;
      }
    }

    const countToAppend = this.minRowCount - body.children.length;

    for (let i = 0; i < countToAppend; i++) {
      const row = document.createElement(`tr`);
      row.classList.add(`table-row-empty`);
      const cell = document.createElement(`td`);
      if (columnCount) {
        cell.setAttribute(`colspan`, columnCount.toString());
      }
      row.appendChild(cell);
      row.style.height = this.rowHeight + `px`;
      body.appendChild(row);
    }
  }

  private findHead(body: HTMLElement): HTMLElement {
    let currentElement = body;
    let head: HTMLElement;
    do {
      currentElement = currentElement.parentElement;
      head = <HTMLElement>Array.from(currentElement.children).find((el: HTMLElement) => el.tagName === `THEAD`);
      const table = <HTMLElement>Array.from(currentElement.children).find((el: HTMLElement) => el.tagName === `TABLE`);
      if (table) {
        const headFromTable = <HTMLElement>Array.from(table.children).find((el: HTMLElement) => el.tagName === `THEAD`);
        if (headFromTable) {
          head = headFromTable;
        }
      }
    }
    while (!head || head.tagName !== `THEAD`);
    return head;
  }
}
